<template>
	<div class="totalGrade-canvas-charts"></div>
</template>

<script>
import echarts from 'echarts'
export default {
	props: {
		newGradingData: Array
	},
	data() {
		return {
			renderTotalGrade: null
		}
	},
	// watch: {
	// 	newGradingData: {
	// 		handler(val) {
	// 		}
	// 	}
	// },
	mounted() {
		this.init()
	},
	methods: {
		init() {
			this.getData()
		},
		getData() {
			// let newGradingData = this.newGradingData.map(item => item.gradeSectionNum)
			this.$nextTick(() => {
				this.drawTotalGrade()
			})
		},
		drawTotalGrade() {
			// console.log(this.newGradingData)
			this.renderTotalGrade = echarts.init(document.querySelector(`.totalGrade-canvas-charts`))
			this.renderTotalGrade.clear()
			this.renderTotalGrade.setOption({
				tooltip: {
					formatter: '{a}:{b}:{c}'
				},
				legend: {
					data: ['全体'],
					icon: 'roundRect',
					selectedMode: false
				},
				color: '#f05f50',
				grid: {
					left: '3%',
					right: '6%',
					bottom: '0%',
					containLabel: true
				},
				xAxis: {
					name: '分数',
					type: 'category',
					boundaryGap: false,
					axisLabel: {
						textStyle: {
							// color: 'green'
						}
					},
					data: this.newGradingData.map(item => item.gradeSection)
					// data: ['0', '18', '36', '54', '72', '90', '108', '116', '134', '152', '170', '188', '200']
				},
				yAxis: {
					type: 'value',
					name: '人数',
					min: Math.min(...this.newGradingData.map(item => parseInt(item.gradeSectionNum))),
					max: Math.max(...this.newGradingData.map(item => parseInt(item.gradeSectionNum))),
					interval: Math.floor(Math.max(...this.newGradingData.map(item => parseInt(item.gradeSectionNum))) / 11)
				},
				series: [
					{
						name: '全体',
						type: 'line',
						stack: '总量',
						data: this.newGradingData.map(item => item.gradeSectionNum),
						// smooth: true,
						label: {
							show: true,
							position: 'top',
							textStyle: {
								color: '#f05f50'
							}
						},
						tooltip: {
							show: true
						},
						lineStyle: {
							color: '#f05f50'
						}
					}
				]
			})
		}
	}
}
</script>

<style></style>
